import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApplicationClientCommonModule, MaterialModule } from '@sdbn/appclient';
import { CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { QRCodeModule } from 'angularx-qrcode';
import { CenteredScrollableContentModule } from 'src/tmc-common/widgets/terminal/centered-scrollable-content/centered-scrollable-content.module';
import { GlobalConnectAppDialog } from './component/global-connect-app-dialog';
import { TransportRegistrationSmartphoneConnectionComponent } from './component/transport-registration-smartphone-connection.component';



@NgModule({
  declarations: [
    TransportRegistrationSmartphoneConnectionComponent,
    GlobalConnectAppDialog
  ],
  imports: [
    CommonModule,
    CommonUIModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    QRCodeModule,
    CenteredScrollableContentModule,
    ApplicationClientCommonModule,
    CommonTranslationModule
  ]
})
export class TransportRegistrationSmartphoneConnectionModule { }
